module.exports = __webpack_public_path__ + "img/delivery-platform-h5-clean.d09d14cb.png";